<div class="w-full sm:w-11/12 flex flex-row gap-1 sm:gap-3 text-slate-50 p-1" [class.hidden]="!isVisible">
    <div class="flex flex-row gap-2 text-faded-70 items-center">
        <svg class="size-6 fill-none stroke-faded-70" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75" />
        </svg>
        <div class="hidden text-sm md:block">
            Filter
        </div>
    </div>
    <preview-item-filter class="grow"></preview-item-filter>
</div>